document.addEventListener('click', function (event) {
  var openSpot = document.querySelector('.image-hotspots__spot.is-active');
  var clickedDot = event.target.closest('.image-hotspots__dot');
  var clickedSpot = clickedDot ? clickedDot.closest('.image-hotspots__spot') : null;

  if (openSpot && openSpot !== clickedSpot) {
    openSpot.classList.remove('is-active');
    var openBtn = openSpot.querySelector('.image-hotspots__dot');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }

  if (clickedDot && clickedSpot) {
    var isActive = clickedSpot.classList.toggle('is-active');
    clickedDot.setAttribute('aria-expanded', isActive ? 'true' : 'false');

    if (isActive) {
      // Flip the card below the dot if there isn't room above it
      var spotRect = clickedSpot.getBoundingClientRect();
      clickedSpot.classList.toggle('image-hotspots__spot--flip-down', spotRect.top < 140);
    }

    // Trigger a one-shot pulse animation on every click
    clickedSpot.classList.remove('is-pulsing');
    // Force reflow so the animation restarts even on rapid re-clicks
    void clickedDot.offsetWidth;
    clickedSpot.classList.add('is-pulsing');
  }
});

document.addEventListener('animationend', function (event) {
  if (event.target.classList.contains('image-hotspots__dot-pulse')) {
    var spot = event.target.closest('.image-hotspots__spot');
    if (spot) spot.classList.remove('is-pulsing');
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    var openSpot = document.querySelector('.image-hotspots__spot.is-active');
    if (openSpot) {
      openSpot.classList.remove('is-active');
      var openBtn = openSpot.querySelector('.image-hotspots__dot');
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.focus();
      }
    }
  }
});